export function getMergedPrefills({ prefills, isAsiLikeMode, }) {
    return isAsiLikeMode && prefills?.length ? prefills : undefined;
}
//# sourceMappingURL=getMergedPrefills.js.map